/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Overviewkpifollowers2Inputs */

const en_overviewkpifollowers2 = /** @type {(inputs: Overviewkpifollowers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Followers`)
};

const de_overviewkpifollowers2 = /** @type {(inputs: Overviewkpifollowers2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follower`)
};

/**
* | output |
* | --- |
* | "Followers" |
*
* @param {Overviewkpifollowers2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const overviewkpifollowers2 = /** @type {((inputs?: Overviewkpifollowers2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Overviewkpifollowers2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_overviewkpifollowers2(inputs)
	return de_overviewkpifollowers2(inputs)
});
export { overviewkpifollowers2 as "overviewKpiFollowers" }